export const FALLBACK_GRAVATAR = 'https://s3.amazonaws.com/tolq_email_assets/clipart/user.png';
export const LOTTIE_LOADING =
  'https://lottie.host/embed/2f77e022-69da-4eee-9435-fd383d2c2b54/B81gtHqkic.json';
export const LOTTIE_WAITING =
  'https://lottie.host/embed/d59c9685-82db-4cd1-9364-c5a444f9d770/yYPsW1OJFB.json';
